import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null; // or a spinner

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
}
